(function () {
    "use strict";

    angular
        .module("app")
        .directive("collectionTypeAhead", ["PrototypeService", collectionTypeAhead]);

    function collectionTypeAhead(prototypeService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return prototypeService.getCollections(scope.brandId, searchText).then(function (response) {
                        if (response) {
                            angular.forEach(response, function (item) {
                                item.DisplayText = item.CollectionDesc + " (" + item.CollectionNum + ")";
                            });
                            return response;
                        }
                        return [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.CollectionNum;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "=", brandId: "="},
            template: '<input' +
                ' uib-typeahead="item.DisplayText for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/> <i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();

